/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Pim.Api | rt-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExportNotificationPayloadExportsInner } from './ExportNotificationPayloadExportsInner';
import {
    ExportNotificationPayloadExportsInnerFromJSON,
    ExportNotificationPayloadExportsInnerFromJSONTyped,
    ExportNotificationPayloadExportsInnerToJSON,
    ExportNotificationPayloadExportsInnerToJSONTyped,
} from './ExportNotificationPayloadExportsInner';

/**
 * A creation, update or deletion of exports of the company.
 * @export
 * @interface ExportNotificationPayload
 */
export interface ExportNotificationPayload {
    /**
     * What happened to the exports.
     * @type {ExportNotificationPayloadOperationEnum}
     * @memberof ExportNotificationPayload
     */
    operation: ExportNotificationPayloadOperationEnum;
    /**
     * The exports that were created, updated or deleted.
     * @type {Array<ExportNotificationPayloadExportsInner>}
     * @memberof ExportNotificationPayload
     */
    exports: Array<ExportNotificationPayloadExportsInner>;
}


/**
 * @export
 */
export const ExportNotificationPayloadOperationEnum = {
    Creation: 'creation',
    Update: 'update',
    Deletion: 'deletion'
} as const;
export type ExportNotificationPayloadOperationEnum = typeof ExportNotificationPayloadOperationEnum[keyof typeof ExportNotificationPayloadOperationEnum];


/**
 * Check if a given object implements the ExportNotificationPayload interface.
 */
export function instanceOfExportNotificationPayload(value: object): value is ExportNotificationPayload {
    if (!('operation' in value) || value['operation'] === undefined) return false;
    if (!('exports' in value) || value['exports'] === undefined) return false;
    return true;
}

export function ExportNotificationPayloadFromJSON(json: any): ExportNotificationPayload {
    return ExportNotificationPayloadFromJSONTyped(json, false);
}

export function ExportNotificationPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportNotificationPayload {
    if (json == null) {
        return json;
    }
    return {
        
        'operation': json['operation'],
        'exports': ((json['exports'] as Array<any>).map(ExportNotificationPayloadExportsInnerFromJSON)),
    };
}

export function ExportNotificationPayloadToJSON(json: any): ExportNotificationPayload {
    return ExportNotificationPayloadToJSONTyped(json, false);
}

export function ExportNotificationPayloadToJSONTyped(value?: ExportNotificationPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation': value['operation'],
        'exports': ((value['exports'] as Array<any>).map(ExportNotificationPayloadExportsInnerToJSON)),
    };
}

